import React from "react";
import classes from "./CollectedMaintenanceCard.module.css";
import MyButton from "../../../../components/MyButton";
import { CiSquareCheck } from "react-icons/ci";
import { FaCheck } from "react-icons/fa6";
import { ImCheckboxUnchecked } from "react-icons/im";
import { commaSeperator } from "../../../../helpers";

const CollectedMaintenanceCard = ({ maintenaceDetails, data, selectMonthHandler, totalCharges }) => {
  const totalDues = +(data?.balanceAmount - (data?.receivedAmount?.split(",").join("")));
  return (
    <>
      <div className={classes["cardMainWrapper"]}>
        <div className={[classes["detailsDiv"], classes["detailsDiv1"]].join(" ")}>
          <p>Rs. {commaSeperator(data?.balanceAmount)}</p>
          <p>Total Maintenance</p>
        </div>
        <div className={[classes["detailsDiv"], classes["detailsDiv2"]].join(" ")}>
          <p>Rs. {data?.receivedAmount}</p>
          <p>Maintenance Collected</p>
        </div>
        <div className={[classes["detailsDiv"], classes["detailsDiv3"]].join(" ")} >
          <p style={{ color: totalDues === 0 && "var(--success-color)" }}>Rs. {commaSeperator(totalDues || 0) || 0}</p>
          <p>Total Dues Remaining</p>
        </div>
      </div>
    </>
  );
};

export default CollectedMaintenanceCard;

const Indicators = ({ selected, text, setter }) => {
  return (
    <MyButton
      className={[
        classes["extraBtnStyle"],
        !selected && classes["selected"],
      ].join(" ")}
      handler={setter}
    >
      {text}
    </MyButton>
  );
};

